import { render, staticRenderFns } from "./ReceiveOrderModal.vue?vue&type=template&id=410af786"
import script from "./ReceiveOrderModal.vue?vue&type=script&lang=ts"
export * from "./ReceiveOrderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports